<template>
  <div class="w-full">
    <h6 class="dashboard__green">Personas mas Invitadas</h6>
    <div class="dashboard__card_container w-full">
      <div class="dashboard__invitations_container">
        <table class="dashboard__table w-full dashboard__normal_table">
          <thead>
            <tr>
              <th></th>
              <th>Invitador</th>
              <th></th>
              <th class="dashboard__green">Invitado</th>
              <th>Tiempo promedio</th>
              <th>Invitaciones</th>
            </tr>
          </thead>
          <tbody class="dashboard__table_darken t_align_center">
            <tr v-for="item of topInvitations" :key="item.id">
              <td><span class="dashboard__profile_image" :style="{'background-image': `url(${item.inviterPhoto})`}"></span></td>
              <td>{{ item.inviterName }}</td>
              <td><span class="dashboard__profile_image" :style="{'background-image': `url(${item.invitedPhoto})`}"></span></td>
              <td class="dashboard__green">{{ item.invitedName }}</td>
              <td class="arial">{{ item.averageApproval }}</td>
              <td class="arial">{{ item.quantity }}</td>
            </tr>
          </tbody>
        </table>
        <table class="dashboard__table w-full dashboard__normal_table">
          <thead>
            <tr>
              <th>Ene</th>
              <th>Feb</th>
              <th>Mar</th>
              <th>Abr</th>
              <th>May</th>
              <th>Jun</th>
              <th>Jul</th>
              <th>Ago</th>
              <th>Sep</th>
              <th>Oct</th>
              <th>Nov</th>
              <th>Dic</th>
            </tr>
          </thead>
          <tbody class="dashboard__table_darken t_align_center">
            <tr v-for="item of topInvitations" :key="item.id">
              <td v-for="val of item.counter" :class="['arial', {'dashboard__table_accent_cell': val === item.greatter}]">{{ val }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardService from '../../../services/DashboardService';

export default {
  data() {
    return {
      topInvitations: [],
    }
  },
  mounted() {
    this.initializeAsync().then(async () => {
      this.setLoader(true);
      this.getTopInvitations();
      this.setLoader(false);
    })
  },
  methods: {
    async getTopInvitations() {
      try {
        const params = {
          location_id: this.getLocation || undefined,
        }
        this.topInvitations = await DashboardService.getTopInvitations(params);
      } catch(err) {
        this.topInvitations = [];
        console.error(err);
        
      }
    },
    async initializeAsync() {
      Promise.resolve(resolve => setTimeout(() => resolve(), 10));
    }
  },
  watch: {
    'getLocation': {
      deep: true,
      handler() {
        this.initializeAsync().then(async () => {
          this.setLoader(true);
          this.getTopInvitations();
          this.setLoader(false);
        });
      }
    }
  }
}
</script>